// extracted by mini-css-extract-plugin
export default {"warstwa":"OchronaTresci_warstwa__rdt0F","siatka":"OchronaTresci_siatka__3kSzk","kafelek":"OchronaTresci_kafelek__mKIBM"};